import { t } from 'i18next';

export default function v_existing_certification(
  value: string | null | undefined,
  args: { isLinked: boolean; message?: string }
) {
  return {
    message: args.message || t('This certification is already linked.'),
    validate: () => !args.isLinked,
  };
}
